import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  retraitArgent: {},
};

export const retraitArgentSlice = createSlice({
  name: "retraitArgent",
  initialState,

  reducers: {
    setRetraitArgentData: (state, action) => {
      const {
        item,
        value,
        type = "RETRAIT_ARGENT",
        date,
      } = action.payload || {};
      if (!item) return;
      if (Array.isArray(state.retraitArgent)) state.retraitArgent = {}; // Guard
      state.retraitArgent[item] = { item, value, type, date };
    },

    setRetraitArgentSent: (state, action) => {
      state.retraitArgentSent = action.payload;
    },

    clearRetraitArgent: (state) => {
      state.retraitArgent = {};
    },
  },
});

export const {
  setRetraitArgentData,
  clearRetraitArgent,
  setRetraitArgentSent,
} = retraitArgentSlice.actions;

export default retraitArgentSlice.reducer;
